export default __webpack_public_path__ + "static/media/social-media-arrow.f5e093ce.svg";